<template>
    <div class="modal modal-open" id="modal-columns-edit">
        <div class="modal-overflow">
            <div class="modal-window">
                <button class="btn btn-modal-close" @click="handleCloseModal">
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="columns-list-wrap">
                        <div class="columns-list-col">
                            <div class="columns-list-col-title">
                                Available columns
                            </div>
                            <div class="columns-datalist">
                                <div
                                    v-for="item in hiddenItems"
                                    v-bind:key="'col_left_' + item.id"
                                    class="columns-datalist-item"
                                    @click="selectColumn(item)"
                                    :class="
                                        selected_col &&
                                        selected_col.id === item.id &&
                                        'selected'
                                    "
                                >
                                    {{ clearTagsFromName(item.name) }}
                                </div>
                            </div>
                        </div>

                        <div class="columns-datalist-controls">
                            <button
                                :disabled="
                                    selected_col === null ||
                                    !selected_col.status === 'show'
                                "
                                class="btn btn--icon btn--col-left"
                                @click="moveToHidden"
                            >
                                <i class="icon icon-left-arrow"></i>
                            </button>
                            <button
                                :disabled="
                                    selected_col === null ||
                                    !selected_col.status === 'hidden'
                                "
                                class="btn btn--icon btn--col-right"
                                @click="moveToShow"
                            >
                                <i class="icon icon-left-arrow"></i>
                            </button>
                        </div>
                        <div class="columns-list-col">
                            <div class="columns-list-col-title">
                                Visible columns
                            </div>
                            <div class="columns-datalist">
                                <div
                                    class="columns-datalist-item"
                                    v-for="item in showItems"
                                    v-bind:key="'col_right_' + item.id"
                                    @click="selectColumn(item)"
                                    :class="
                                        selected_col &&
                                        selected_col.id === item.id &&
                                        'selected'
                                    "
                                >
                                    {{ clearTagsFromName(item.name) }} ({{
                                        item.position
                                    }})
                                </div>
                            </div>
                        </div>

                        <div class="columns-datalist-controls">
                            <button
                                :disabled="isHiddenItem"
                                class="btn btn--icon btn--col-up"
                                @click="changePositionToUp"
                            >
                                <i class="icon icon-down-arrow"></i>
                            </button>
                            <button
                                :disabled="isHiddenItem"
                                class="btn btn--icon btn--col-down"
                                @click="changePositionToDown"
                            >
                                <i class="icon icon-down-arrow"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Columns_Modal",
    data() {
        return {
            filter_columns: [],
        };
    },
    props: ["__columns", "selectColumn", "closeModal", "selected_col"],
    mounted() {
        this.filter_columns = JSON.parse(JSON.stringify(this.__columns));
    },
    computed: {
        hiddenItems() {
            if (!this.filter_columns.length) {
                return [];
            }

            return this.filter_columns.filter(
                (item) => item.status === "hidden"
            );
        },
        showItems() {
            try {
                if (!this.filter_columns.length) {
                    return [];
                }

                return this.filter_columns
                    .filter((item) => item.status === "show")
                    .sort((a, b) => a.position - b.position);
            } catch (err) {
                console.error("showItems error", err);
            }
        },
        isHiddenItem() {
            if (this.selected_col) {
                return this.selected_col.status === "hidden";
            }
            return true;
        },
    },
    methods: {
        moveToHidden() {
            this.filter_columns = this.filter_columns.map((col) => {
                if (col.id === this.selected_col.id) {
                    col.status = "hidden";
                    return col;
                }
                return col;
            });
        },
        moveToShow() {
            this.filter_columns = this.filter_columns.map((col) => {
                if (col.id === this.selected_col.id) {
                    col.status = "show";
                    return col;
                }
                return col;
            });
        },

        changePositionToUp() {
            const _index = this.filter_columns.findIndex(
                (item) => item.id === this.selected_col.id
            );

            if (_index !== 0) {
                let el = this.filter_columns[_index];
                this.filter_columns[_index] = this.filter_columns[_index - 1];
                this.filter_columns[_index - 1] = el;

                const showItems = this.filter_columns.filter(
                    (item) => item.status === "show"
                );
                const hiddenItems = this.filter_columns.filter(
                    (item) => item.status === "hidden"
                );

                this.filter_columns.length = 0;
                this.filter_columns = [...showItems, ...hiddenItems];
                this.filter_columns.forEach((i, index) => {
                    i.position = index + 1;
                });
            }
        },

        changePositionToDown() {
            const _index = this.filter_columns.findIndex(
                (item) => item.id === this.selected_col.id
            );

            if (_index !== -1 && _index < this.filter_columns.length - 1) {
                let el = this.filter_columns[_index];
                this.filter_columns[_index] = this.filter_columns[_index + 1];
                this.filter_columns[_index + 1] = el;

                // this.filter_columns.forEach((i, index) => {
                //     i.position = index + 1;
                // });

                const showItems = this.filter_columns.filter(
                    (item) => item.status === "show"
                );
                const hiddenItems = this.filter_columns.filter(
                    (item) => item.status === "hidden"
                );

                this.filter_columns.length = 0;
                this.filter_columns = [...showItems, ...hiddenItems];
                this.filter_columns.forEach((i, index) => {
                    i.position = index + 1;
                });
            }
        },

        handleCloseModal() {
            this.closeModal(this.filter_columns);
        },

        clearTagsFromName(name) {
            const _name = name
                .replace("&nbsp;", " ")
                .replace("&nbsp;", " ")
                .replace("<br/>", "")
                .replace("<br />", "");

            return _name || "";
        },
    },
};
</script>
